let intl

export function setInstance(intlInstance) {
  intl = intlInstance
}

export default function getInstance() {
  return intl
}
